import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

import { paths } from 'src/config/paths'
import { useChatClient } from 'src/features/chats/context/chat-context'
import { ChatFilled } from 'src/shared/components/icons/chat/chat-filled'
import { Button } from 'src/shared/components/ui/buttons/button'
import { useMyUserData } from 'src/shared/features/users/api/accounts/use-my-user'

const ChatButton = () => {
  const navigate = useNavigate()
  const { data: user } = useMyUserData()
  const { client } = useChatClient()
  const [totalUnreadCount, setTotalUnreadCount] = useState<number>(0)

  useEffect(() => {
    const fetchUnreadCount = async () => {
      if (client && user) {
        try {
          const result = await client.getUnreadCount(user.id.toString())
          setTotalUnreadCount(result.total_unread_count)
        } catch (error) {
          console.error('Error fetching unread count:', error)
        }
      }
    }

    fetchUnreadCount()

    // Set up a listener for new messages
    const handleNewMessage = () => {
      fetchUnreadCount()
    }

    if (client) {
      client.on('message.new', handleNewMessage)
    }

    return () => {
      if (client) {
        client.off('message.new', handleNewMessage)
      }
    }
  }, [client, user])

  const handleChatClick = () => {
    navigate(paths.chats.list.getHref())
  }

  return (
    <Button variant="ghost" size="icon" onClick={handleChatClick} className="size-8">
      <div className="flex size-10 shrink-0 items-center justify-center rounded-full bg-primary">
        <ChatFilled className="size-[18px] text-white" />
      </div>
      {totalUnreadCount > 0 && (
        <span className="absolute -right-2 -top-1 flex size-4 items-center justify-center rounded-full bg-destructive text-[10px] text-destructive-foreground">
          {totalUnreadCount}
        </span>
      )}
    </Button>
  )
}

export default ChatButton
